/* eslint-disable react/jsx-props-no-spreading */

import React, { FC, ReactNode } from 'react'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { TeamMemberModalSchema, TeamMemberModalSchemaType } from 'apps/fleet-planner/schema'

interface TeamMemberFormProviderProps {
  children: ReactNode
}

/**
 * Provides form methods and data for all children elements
 */
export const TeamMemberFormProvider: FC<TeamMemberFormProviderProps> = ({ children }) => {
  const methods = useForm<TeamMemberModalSchemaType>({
    mode: 'onBlur',
    resolver: yupResolver(TeamMemberModalSchema),
    defaultValues: {
      ...TeamMemberModalSchema.cast({
        firstName: '',
        lastName: '',
        cellPhone: '',
        phone: '',
        email: '',
        motorCarrierDetails: [],
        smsStatusUpdatesEnabled: false,
      }),
    },
  })
  return <FormProvider {...methods}>{children}</FormProvider>
}

// Helper function for context
export const useTeamMemberFormContext = () => useFormContext<TeamMemberModalSchemaType>()
